import Tag from '@apigrowfinance/pbolt-tag';
import dayjs from 'dayjs';
import { RiCheckboxCircleLine, RiCloseCircleLine } from 'react-icons/ri';
import { FormattedMessage } from 'react-intl';

import { Bucket } from '@clients/domains/delinquency/delinquencyBuckets';

export type DelinquencyChipsProps = {
    delinquencyBucket: Bucket;
};

const DelinquencyChips = ({ delinquencyBucket }: DelinquencyChipsProps) => {
    const isPartPaid =
        delinquencyBucket?.bucket_amount !==
            delinquencyBucket?.bucket_balance &&
        delinquencyBucket?.bucket_balance > 0;

    const isOverdue = delinquencyBucket?.bucket_balance > 0;
    const howLongOverdue = dayjs().diff(delinquencyBucket?.created_at, 'days');

    const overDuePaid =
        delinquencyBucket?.bucket_amount > 0 &&
        delinquencyBucket?.bucket_balance === 0;

    const howLongToBePaid = dayjs(delinquencyBucket?.updated_at).diff(
        delinquencyBucket?.created_at,
        'days',
    );

    return (
        <>
            {overDuePaid && delinquencyBucket?.updated_at && (
                <Tag
                    icon={<RiCheckboxCircleLine />}
                    color="success"
                    label={
                        <FormattedMessage
                            id="delinquency.overDuePaid"
                            defaultMessage="Overdue amount paid {days} days late"
                            values={{ days: howLongToBePaid }}
                        />
                    }
                    filled
                />
            )}
            {isPartPaid && (
                <Tag
                    icon={<RiCheckboxCircleLine />}
                    color="success"
                    label={
                        <FormattedMessage
                            id="delinquency.partPaid"
                            defaultMessage="Part paid"
                        />
                    }
                    filled
                />
            )}
            {isOverdue && (
                <Tag
                    icon={<RiCloseCircleLine />}
                    color="error"
                    label={
                        <FormattedMessage
                            id="delinquency.overDue"
                            defaultMessage="{days} days overdue"
                            values={{ days: howLongOverdue }}
                        />
                    }
                    filled
                />
            )}
            <span />
        </>
    );
};

export default DelinquencyChips;
